export default class extends HTMLElement {
  connectedCallback () {
    this.time = 20

    if (this.radio.checked) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.start()
            this.observer.disconnect()
          }
        })
      }, { threshold: 0.1 })

      this.observer.observe(this)
    }

    this.radio.addEventListener('change', (e) => {
      this.items.forEach((item) => {
        if (item.contains(e.target)) {
          item.start()
          item.activate()
        } else {
          item.stop()
        }
      })
    })
  }

  disconnectedCallback () {
    this.stop()

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  start () {
    if (this.interval) return

    const toMs = t => (Number(t) || 40) * 1225

    this.durationMs = toMs(this.time)
    this.lastTime = this.time
    this.startTime = performance.now()

    this.progressCircle.style.setProperty('--angle', '0deg')

    const tickInterval = 40

    this.interval = setInterval(() => {
      this.updateProgress()

      const now = performance.now()

      if (now - this.startTime >= this.durationMs) {
        this.progressCircle.style.setProperty('--angle', '360deg')
        clearInterval(this.interval)
        this.interval = null
        this.moveToNext()
      }
    }, tickInterval)
  }

  moveToNext () {
    const nextItem = this.items[(this.items.indexOf(this) + 1) % this.items.length]

    nextItem.radio.checked = true
    nextItem.radio.dispatchEvent(new Event('change', { bubbles: true }))

    nextItem.activate()
  }

  activate () {
    const step = document.getElementById(this.dataset.stepId)
    const cards = [...step.parentNode.children]

    cards.forEach((e) => e.classList.add('hidden'))

    step.classList.remove('hidden')
  }

  stop () {
    if (this.interval) {
      clearInterval(this.interval)

      this.interval = null
    }

    this.startTime = null
    this.durationMs = null
    this.lastTime = null
    this.progressCircle.style.setProperty('--angle', '0deg')
  }

  updateProgress () {
    if (!this.startTime) return

    const toMs = t => (Number(t) || 40) * 1225
    const now = performance.now()

    if (this.lastTime !== this.time) {
      const oldDur = this.durationMs ?? toMs(this.lastTime)
      const k = Math.min(1, Math.max(0, (now - this.startTime) / oldDur))
      const newDur = toMs(this.time)

      this.startTime = now - k * newDur
      this.durationMs = newDur
      this.lastTime = this.time
    }

    const k = Math.min(1, Math.max(0, (now - this.startTime) / this.durationMs))
    const angle = 360 * k

    this.progressCircle.style.setProperty('--angle', angle + 'deg')
  }

  get items () {
    return [...this.parentNode.querySelectorAll('carousel-item')]
  }

  get progressCircle () {
    return this.querySelector('.radar-progress')
  }

  get radio () {
    return this.querySelector('input[type="radio"]')
  }
}
